import React, { useRef } from 'react';
import { FaMagic, FaTrash, FaCloudUploadAlt } from 'react-icons/fa';
import { getRandomColor } from '../utils/qr-helper';

const DesignPanel = ({ config, setConfig, onMagicClick }) => {
  const fileInputRef = useRef(null);

  const handleColorChange = (key, value) => {
    setConfig(prev => ({ ...prev, [key]: value }));
  };

  const handleStyleChange = (key, value) => {
    setConfig(prev => ({ ...prev, [key]: value }));
  };

  const handleLogoUpload = (e) => {
    const file = e.target.files?.[0];
    if (file) {
      const reader = new FileReader();
      reader.onload = (e) => {
        setConfig(prev => ({ ...prev, logo: e.target.result }));
      };
      reader.readAsDataURL(file);
    }
  };

  const removeLogo = () => {
    setConfig(prev => ({ ...prev, logo: null }));
    if (fileInputRef.current) fileInputRef.current.value = '';
  };

  return (
    <div className="space-y-8">
      {/* 樣式選擇 */}
      <div className="grid grid-cols-2 gap-4">
        <div>
          <label className="block text-sm font-medium text-slate-300 mb-2">點樣式</label>
          <select 
            className="glass-input appearance-none cursor-pointer"
            value={config.dotStyle}
            onChange={(e) => handleStyleChange('dotStyle', e.target.value)}
          >
            <option value="square">方形</option>
            <option value="rounded">圓角</option>
            <option value="dots">點狀</option>
          </select>
        </div>
        <div>
          <label className="block text-sm font-medium text-slate-300 mb-2">角落樣式</label>
          <select 
            className="glass-input appearance-none cursor-pointer"
            value={config.cornerStyle}
            onChange={(e) => handleStyleChange('cornerStyle', e.target.value)}
          >
            <option value="square">方形</option>
            <option value="rounded">圓角</option>
            <option value="dots">點狀</option>
          </select>
        </div>
      </div>

      {/* 顏色選擇 */}
      <div className="space-y-4">
        <label className="block text-sm font-medium text-slate-300">配色方案</label>
        <div className="flex gap-4">
          <div className="flex-1">
            <div className="text-xs text-slate-400 mb-1">前景顏色</div>
            <div className="flex items-center gap-3 p-3 rounded-lg border border-white/10 bg-dark-900/50">
              <input 
                type="color" 
                value={config.fgColor} 
                onChange={(e) => handleColorChange('fgColor', e.target.value)}
                className="w-8 h-8 rounded cursor-pointer bg-transparent border-none p-0"
              />
              <span className="text-sm font-mono text-slate-300">{config.fgColor.toUpperCase()}</span>
            </div>
          </div>
          <div className="flex-1">
            <div className="text-xs text-slate-400 mb-1">背景顏色</div>
            <div className="flex items-center gap-3 p-3 rounded-lg border border-white/10 bg-dark-900/50">
              <input 
                type="color" 
                value={config.bgColor} 
                onChange={(e) => handleColorChange('bgColor', e.target.value)}
                className="w-8 h-8 rounded cursor-pointer bg-transparent border-none p-0"
              />
              <span className="text-sm font-mono text-slate-300">{config.bgColor.toUpperCase()}</span>
            </div>
          </div>
        </div>
        
        <button 
          onClick={onMagicClick}
          className="w-full py-3 rounded-xl bg-gradient-to-r from-accent-light to-accent text-white font-bold flex items-center justify-center gap-2 hover:shadow-lg hover:shadow-accent/30 transition-all active:scale-95 group overflow-hidden relative"
        >
          <div className="absolute inset-0 bg-white/20 translate-y-full group-hover:translate-y-0 transition-transform duration-300 skew-y-12"></div>
          <FaMagic className="group-hover:rotate-12 transition-transform" />
          <span>魔法隨機配色</span>
        </button>
      </div>

      {/* Logo 上傳 */}
      <div>
        <label className="block text-sm font-medium text-slate-300 mb-2">Logo 設定</label>
        {!config.logo ? (
          <div 
            onClick={() => fileInputRef.current?.click()}
            className="border-2 border-dashed border-slate-600 rounded-xl p-6 text-center cursor-pointer hover:border-primary hover:bg-slate-800/50 transition-colors group"
          >
            <FaCloudUploadAlt className="mx-auto text-3xl text-slate-500 mb-2 group-hover:text-primary transition-colors" />
            <p className="text-sm text-slate-400 group-hover:text-slate-200">點擊上傳 Logo 圖片</p>
          </div>
        ) : (
          <div className="bg-slate-800/50 p-4 rounded-xl border border-white/10 flex items-center justify-between">
            <div className="flex items-center gap-3">
              <div className="w-12 h-12 rounded-lg bg-white/10 p-1">
                <img src={config.logo} alt="Logo Preview" className="w-full h-full object-contain" />
              </div>
              <span className="text-sm text-slate-300">已上傳 Logo</span>
            </div>
            <button 
              onClick={removeLogo}
              className="p-2 text-slate-400 hover:text-red-400 hover:bg-red-400/10 rounded-lg transition-colors"
            >
              <FaTrash />
            </button>
          </div>
        )}
        <input 
          type="file" 
          ref={fileInputRef} 
          className="hidden" 
          accept="image/*"
          onChange={handleLogoUpload}
        />
      </div>
    </div>
  );
};

export default DesignPanel;